import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const LineChart = ({ title, getLabel, data, tooltipName, style }) => {
  return (
    <Col md={12}>
      <Card className="student-chart-card">
        <CardBody>
          <h5 className="card-title mb-3">{title}</h5>
          <div className="mb-3">
            <ReactApexChart
              options={{
                chart: {
                  height: 450,
                  type: "area",
                  stacked: false,
                  zoom: {
                    type: "x",
                    enabled: true,
                    autoScaleYaxis: false,
                  },
                  toolbar: {
                    autoSelected: "zoom",
                    tools: {
                      download: false,
                      selection: false,
                      pan: false,
                      reset: false,
                      zoom: false,
                      zoomin: false,
                      zoomout: false,
                    },
                  },
                },
                markers: {
                  size: 5,
                  colors: [style.color],
                  strokeColors: "#fff",
                  strokeWidth: 2,
                  hover: {
                    size: 7,
                  },
                },
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  curve: "smooth",
                  width: 3,
                },
                fill: {
                  type: "gradient",
                  gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.45,
                    opacityTo: 0.05,
                    stops: [0, 90, 100],
                  },
                },
                grid: {
                  show: true,
                  borderColor: "#f1f1f1",
                  padding: {
                    left: 25,
                    right: 20,
                  },
                  xaxis: {
                    lines: {
                      show: false,
                    },
                  },
                  yaxis: {
                    lines: {
                      show: true,
                    },
                  },
                },
                colors: [style.color],
                tooltip: {
                  shared: false,
                  y: {
                    formatter: (value) => getLabel(Math.round(value)),
                  },
                },
                xaxis: {
                  type: "category",
                  labels: {
                    offsetX: 0,
                    show: true,
                    style: {
                      fontSize: style.fontSize,
                      fontWeight: style.fontWeight,
                    },
                    formatter: (value) => {
                      if (!value) return "";
                      const numVal = Number(value);
                      if (!isNaN(numVal) && numVal > 100000000000) {
                        return new Date(numVal).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        });
                      }
                      return value;
                    },
                  },
                },
                yaxis: {
                  opposite: false,
                  showAlways: true,
                  labels: {
                    offsetX: 5,
                    show: true,
                    style: {
                      fontSize: style.fontSize,
                      fontWeight: style.fontWeight,
                      colors: style.color,
                    },
                    formatter: (value) => {
                      const rounded = Math.round(value);
                      if (Math.abs(value - rounded) < 0.1) {
                        return getLabel(rounded);
                      }
                      return "";
                    },
                  },
                },
              }}
              series={[
                {
                  name: tooltipName,
                  data: data?.map((ele) => {
                    return {
                      x: ele.id,
                      y: ele.value,
                    };
                  }),
                },
              ]}
              type="area"
              height="450"
              className="apex-charts"
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LineChart;
